import Label from '@/components/inputs/Label';
import { RadioButton } from '@/components/inputs/RadioButton';
import { TableFilter } from '@/types/table';
import { RadioGroup } from '@headlessui/react';

interface RadioButtonFilterProps {
    name: string;
    label: string;
    appliedFilters: Record<string, TableFilter<any>>;
    radioButtonFilters: { label: string; value: string; description?: string }[];
    setFilterFields: (names: string[], values: any[]) => void;
}

const RadioButtonFilter = (props: RadioButtonFilterProps) => {
    const { name, label, appliedFilters, radioButtonFilters, setFilterFields } = props;

    const value = appliedFilters[name]?.value;
    return (
        <div className="flex items-center gap-2 h-[34px] text-xs w-fit">
            <Label className="sm:min-w-32" label={label} />
            <div className="h-full flex items-center relative px-2.5 border border-brand-neutral-700 hover:border-brand-neutral-600 rounded-md">
                <RadioGroup
                    className="flex gap-3 text-xs"
                    value={value}
                    onChange={(filter) =>
                        setFilterFields(
                            [name],
                            [
                                {
                                    value: filter,
                                    label
                                }
                            ]
                        )
                    }>
                    {radioButtonFilters.map((filter, index) => {
                        return (
                            <RadioGroup.Option
                                className="!p-0"
                                key={`${filter.value}-${index}-${name}`}
                                title={filter.description}
                                value={filter.value}>
                                {({ checked }) => {
                                    return (
                                        <RadioButton
                                            id={`${filter.value}-${index}-${name}`}
                                            name={`${filter.value}-${index}-${name}`}
                                            checked={checked}
                                            className="p-0">
                                            {filter.label}
                                        </RadioButton>
                                    );
                                }}
                            </RadioGroup.Option>
                        );
                    })}
                </RadioGroup>
            </div>
        </div>
    );
};

export default RadioButtonFilter;
